import { Row, Col, Card, Table, Modal } from "antd";
import { ReactComponent as Logo } from "../../../assets/images/Frame 2147225328.svg";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import { EventType, BreakTypeEnum } from "../../../Common/constant";
import { format, differenceInMinutes, parseISO } from "date-fns";
import { useParams } from "react-router-dom";
import { ReactComponent as MapIcon } from "../../../assets/images/Group 1000004561.svg";
import MapComponent from "../../../Reusablecomponents/MapComponent";
import dayjs from "dayjs";
export const TitleStyle = styled.div`
  .mapcontainer_fluxuation {
    height: 450px;
    over-flow: hidden;
  }
  .newmap_container {
    height: 100%;
    overflow: hidden;
  }
  .title {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    width: 205;
    height: 17;
    color: #363636;
  }
  p {
    margin: 0px;
    line-height: 0.8;
    padding: 3px;
  }
  /* .ant-table-cell {
  padding: 0px !important;

} */

  .ant-table-row:nth-child(odd) > td.ant-table-cell {
    padding: 3px !important;
  }

  .ant-table-row:nth-child(even) > td.ant-table-cell {
    padding: 3px !important;
    height: 40px !important;
  }
  .ant-card-body {
    padding: 10px !important;
  }
  /* .ant-table-row:nth-child(odd) {
  padding: 10px 0px 6px 0px !important;

} */
`;
const calculateDuration1 = (minutes) => {
      const totalMinutes = Number(minutes) || 0;

      const days = Math.floor(totalMinutes / (24 * 60));
      const remainingMinutesAfterDays = totalMinutes % (24 * 60);

      const hours = Math.floor(remainingMinutesAfterDays / 60);
      const mins = remainingMinutesAfterDays % 60;

      if (days > 0) {
        return `${String(days).padStart(2, "0")}:${String(hours).padStart(
          2,
          "0",
        )}:${String(mins).padStart(2, "0")}`;
      }

      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`};

const tripBreakColumns = [
  {
    title: "Break Type",
    dataIndex: "STARTED",
    key: "STARTED",
    render: (text) => (text ? "Started" : "Ended"),
  },
  {
    title: "Break Type",
    dataIndex: "BreakType",
    key: "BreakType",
    render: (text) => {
      const breakType = BreakTypeEnum?.find((item) => item?.value === text);
      return breakType?.name || "Unknown";
    },
  },
  {
    title: "Location",
    dataIndex: "LOC",
    key: "LOC",
    render: (text) => (
      <div
        style={{
          wordWrap: "break-word",
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        {text || "-"}
      </div>
    ),
  },
  {
    title: "Updated",
    dataIndex: "CRON",
    render: (text) => {
      if (!text) return "N/A"; // Handle empty or null values
      const formattedDate = format(new Date(text), "dd-MM-yyyy");
      const formattedTime = format(new Date(text), "HH:mm");
      return (
        <>
          <TitleStyle>
            <p>{formattedDate}</p>
            <p>{formattedTime}</p>
          </TitleStyle>
        </>
      );
    },
  },
  {
    title: "Break Time",
    dataIndex: "Duration",
    key: "Duration",
    render: (minutes) => {
      const totalMinutes = Number(minutes) || 0;

      const days = Math.floor(totalMinutes / (24 * 60));
      const remainingMinutesAfterDays = totalMinutes % (24 * 60);

      const hours = Math.floor(remainingMinutesAfterDays / 60);
      const mins = remainingMinutesAfterDays % 60;

      if (days > 0) {
        return `${String(days).padStart(2, "0")}:${String(hours).padStart(
          2,
          "0",
        )}:${String(mins).padStart(2, "0")}`;
      }

      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    },
  },
];

const consignColumns = [
  {
    title: "Consign Code",
    dataIndex: "Code",
    key: "Code",
  },
  {
    title: "Consignor",
    dataIndex: "CustName",
    key: "CustName",
  },
  {
    title: "Consignee",
    dataIndex: "RecName",
    key: "RecName",
  },
  {
    title: "Transporter",
    dataIndex: "ShipperName",
    key: "ShipperName",
  },
  {
    title: "Event Status",
    dataIndex: "LastModify",
    key: "LastModify",
    render: (text, record) => {
      const event = EventType?.find((item) => item.value === text);
      const eventName = event?.name || "-";
      return <span>{`${eventName}`}</span>;
    },
  },
];

const TrackRightPage = () => {
  const { tripId } = useParams();
  const [eventData, setEventData] = useState([]);
  const [tripBreakData, setTripBreakData] = useState([]);
  const [consignData, setConsignData] = useState([]);
  const [summaryData1, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [startEndLoc, setStartEndloc] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const MCID = searchParams.get("MCID");
  const fetchEventTable = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trakingLink/getCompletedEvents`, {
      TripId: tripId,
      MCID: MCID,
    });
    setEventData(data);
    setLoading(false);
  };
  const fetchTripBreakTable = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trackingLink/getTripBreakList`, {
      TripId: tripId,
      MCID: MCID,
    });
    setTripBreakData(data);
    setLoading(false);
  };
  const fetchConsignData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trackingLink/getByIdDL`, {
      TripID: tripId,
      MCID: MCID,
    });
    setConsignData(Array.isArray(data?.Consignments) ? data?.Consignments : []);
    setLoading(false);
  };

  const getSingleConsinment = async () => {
    let consignmentId = null;
    if (Array.isArray(consignData) && consignData.length > 0) {
      consignmentId = consignData[0].ConsignmentId;
    } else {
      // No consignment data available
      return;
    }

    const { data } = await CALL_API("POST", "getSingleConsignById", {
      consignId: consignmentId,
      MCID: MCID,
    });

    if (data) {
      const { STARTLAT, STARTLNG, ENDLAT, ENDLNG } = data;

      setStartEndloc([
        {
          lat: parseFloat(STARTLAT),
          lng: parseFloat(STARTLNG),
        },
        {
          lat: parseFloat(ENDLAT),
          lng: parseFloat(ENDLNG),
        },
      ]);
    }
  };

  const fetchSummaryData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trackingLink/getByIdDL`, {
      TripID: tripId,
      MCID: MCID,
    });
    setSummaryData(data);
    setLoading(false);
  };

  const raiseKPIAlertAuto = async () => {
    const { data } = await CALL_API("POST", `AIPlus/raiseKPIAlertAuto`, {
      MCID: Number(MCID),
    });
  };

  const getlocation = async () => {
    const { data } = await CALL_API(
      "POST",
      `trackingLink/getAllLocationByTripId`,
      { TripId: tripId, MCID: MCID },
    );
    setLocationData(data);
  };
  useEffect(() => {
    if (tripId) {
      fetchEventTable();
      fetchTripBreakTable();
      fetchConsignData();
      fetchSummaryData();
      getlocation();
    }
  }, [tripId]);
  useEffect(() => {
    getSingleConsinment();
    raiseKPIAlertAuto();
  }, []);
  // Handlers for modal
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const eventColumns = [
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text, record) => {
        const event = EventType?.find((item) => item.value === text);
        const eventName = event?.name || "-";
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <MapIcon
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => {
                handleOpenModal();
                setSelectedRecord(record);
              }}
            />
            <span>{`${eventName}`}</span>
          </div>
        );
      },
    },
    {
      title: "Consignee",
      dataIndex: "Consignee",
      key: "Consignee",
    },
    {
      title: "Updated by",
      dataIndex: "UserName",
      key: "UserName",

      render: (text, record) => {
        const formattedDate = dayjs(record.MODON).isValid()
          ? dayjs(record.MODON).format("DD MMM YYYY, HH:mm")
          : "12 Jun 2025, 14:40";
        return (
          <>
            <p>{text}</p>
            <p>{formattedDate}</p>
          </>
        );
      },
    },
  ];
  // Utility function to calculate duration
  function calculateDuration(start, end) {
    if (!start || !end) return "N/A";
    try {
      const minutes = differenceInMinutes(new Date(end), new Date(start));
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours}H ${mins}M`;
    } catch (error) {
      return "Invalid Date";
    }
  }

  const summaryData = [
    { label: "Driver Name", value: summaryData1?.DriverName },
    { label: "Vehicle", value: summaryData1?.RegNo },
    { label: "Trip", value: summaryData1?.CODE },
    {
      label: "Carbon Footprint",
      value: summaryData1?.CarbonFootprint ?? "-",
    },
    {
      label: "Total Trip Time",
      value: calculateDuration(
        summaryData1?.FirstEventTime,
        summaryData1?.LastEventTime,
      ),
    },
    { label: "Break Time", value: `${calculateDuration1(summaryData1?.BreakMinutes || 0)}` },
    {
      label: "Last Location",
      value: summaryData1?.Consignments?.[0]?.StartLocation ?? "-",
    },
    {
      label: "Destination Location",
      value: summaryData1?.Consignments?.[0]?.EndLocation ?? "-",
    },
  ];

  const handleclicklogo = () => {
    window.open("https://trackright.africa/", "_blank");
  };

  return (
    <>
      {" "}
      <TitleStyle>
        <div
          onClick={handleclicklogo}
          style={{
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
            textAlign: "center",
            backgroundColor: "#ffffff",
            cursor: "pointer",
          }}
        >
          <Logo
            style={{
              width: "129.06866455078125",
              height: "24px",
              marginBottom: "8px",
            }}
          />
          <p className="title">(Live Consignment Tracking)</p>
        </div>

        <Row gutter={16}>
          {/* Left Column */}
          <Col xs={24} md={14}>
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "10px",
                marginBottom: "16px",
              }}
            >
              <Card>
                <MapComponent
                  routePoints={startEndLoc}
                  locationsTL={locationData}
                  // locationsTLAI={locationData}
                  tracklinkAiplus={true}
                  locationsTLAI={eventData}
                  summaryData={summaryData1}
                  driverNametracklinkplus={summaryData1?.DriverName}
                  containerDetailMap={
                    selectedRecord?.Lat && selectedRecord?.Lng
                      ? {
                          FLatitude: selectedRecord.Lat,
                          FLongitude: selectedRecord.Lng,
                          locationName:
                            selectedRecord?.ConsigneeName || "Unknown Location",
                        }
                      : null
                  }
                />
              </Card>
              {/* Map Placeholder */}
            </div>

            <Card title="Consignments">
              <StyledTable
                columns={consignColumns}
                dataSource={consignData}
                pagination={false}
              />
            </Card>
          </Col>

          {/* Right Column */}
          <Col xs={24} md={10}>
            <Card
              title={`Trip Info`}
              extra={
                <span>
                  <span style={{ color: "#000" }}>Status </span>
                  <span
                    style={{
                      color: summaryData1?.STATUS === 4 ? "green" : "orange",
                    }}
                  >
                    ● {summaryData1?.STATUS === 4 ? "Completed" : "In Progress"}
                  </span>
                </span>
              }
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  rowGap: 12,
                }}
              >
                {summaryData.map((item, index) => (
                  <div key={index}>
                    <strong>{item.label}</strong>
                    <div>{item.value}</div>
                  </div>
                ))}
              </div>
            </Card>

            {/* <Card title="Consign Code - 23123" style={{ marginTop: 16 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                rowGap: 12,
              }}
            >
              {consignData.map((item, index) => (
                <div key={index}>
                  <strong>{item.label}</strong>
                  <div>{item.value}</div>
                </div>
              ))}
            </div>
          </Card> */}

            <Card title="Trip Break(s)" style={{ marginTop: 16 }}>
              <StyledTable
                columns={tripBreakColumns}
                dataSource={tripBreakData}
                pagination={false}
              />
            </Card>

            <Card title="Events" style={{ marginTop: 16 }}>
              <StyledTable
                columns={eventColumns}
                dataSource={eventData}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </TitleStyle>
      <Modal
        title="Event Location"
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <TitleStyle>
          <div
            className="mapcontainer_fluxuation"
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              marginBottom: "16px",
            }}
          >
            <div className="newmap_container">
              <MapComponent
                locationsTL={[selectedRecord]}
                isminimap={true}
                tracklinkplus={true}
                driverNametracklinkplus={summaryData1?.DriverName}
                containerDetailMap={
                  selectedRecord?.Lat && selectedRecord?.Lng
                    ? {
                        FLatitude: selectedRecord.Lat,
                        FLongitude: selectedRecord.Lng,
                        locationName:
                          selectedRecord?.ConsigneeName || "Unknown Location",
                      }
                    : null
                }
              />
            </div>
          </div>
        </TitleStyle>
      </Modal>
    </>
  );
};

export default TrackRightPage;
